export const FIELD_CLASS_NAME = 'col-12 col-sm-6'
